export default __webpack_public_path__ + "static/interactive-modules-teaser-b0b338768ccb9e57a35d6aefe8811adf.png";